import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import NavView from '../component/NavView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import * as APJHttp from '../store/APJHttp';
import { getImgPath } from '../store/JSTool';
import FeedSuccessAlert from '../component/FeedSuccessAlert';


export default function ContactPage() {

    let navId = 'contact_us_page_nav';
    let pageId = 'contact_us_page_div';
    let sectionIdAry = ['contact_us_news'];
    const settingData = useSelector(state => state.settingData);

    const dispatch = useDispatch();

    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);
    }, []);

    function submitTap() {
        const name = $('#feed_name')[0].value;
        const company = $('#feed_company')[0].value;
        const message = $('#feed_msg')[0].value;
        const email = $('#feed_email')[0].value;
        const mobile = $('#feed_mobile')[0].value;

        if (JSTool.isEmpty(name)) {
            showToast('Please input name');
            return;
        }
        if (JSTool.isEmpty(company)) {
            showToast('Please input company');
            return;
        }
        if (JSTool.isEmpty(message)) {
            showToast('Please input message');
            return;
        }
        if (JSTool.isEmpty(email)) {
            showToast('Please input email');
            return;
        }

        dispatch(settingActions.showLoading(true));
        APJHttp.submitFeedback(name, company, message, email, mobile, (data) => {
            dispatch(settingActions.showLoading(false));
            clearInput();
            dispatch(settingActions.showFeedSuccessAlert(true));

        }, (code, msg) => {
            dispatch(settingActions.showLoading(false));
            dispatch(settingActions.showToast(`code ${code}: ${msg}`));
        });
    }

    function clearInput() {
        $('#feed_name')[0].value = '';
        $('#feed_company')[0].value = '';
        $('#feed_msg')[0].value = '';
        $('#feed_email')[0].value = '';
        $('#feed_mobile')[0].value = '';
    }

    function showToast(msg) {
        dispatch(settingActions.showToast(msg));
    }

    return (
        <Stack component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>
            <NavView navId={navId} pageId={pageId} />

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                    minHeight: '100vh',
                }} >

                <Stack sx={{
                    width: 1,
                    bgcolor: 'black',
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath('apj_banner_2.png')}
                        sx={{
                            opacity: 0.5,
                            width: 1,
                            maxHeight: '300px',
                            minHeight: '150px',
                            objectFit: 'cover',
                        }} />
                </Stack>

                <Typography sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    width: '1100px',
                    mt: 3,
                    mb: 1,
                    fontFamily: settingData.fontFM,
                    textAlign: 'justify'
                }}>
                    <span style={{ fontSize: 23 }}>{settingData.langDic['lang32_title']}</span>

                    <Box
                    component={'span'}
                        sx={{
                           
                        }}
                        dangerouslySetInnerHTML={{
                            __html:
                                `
                        ${settingData.langDic['lang32']}
                        `
                        }} />


                    {/* {settingData.langDic['lang32']} */}
                </Typography>


                <SectionView id={sectionIdAry[0]} title='Contact Us' />

                <Typography sx={{
                    fontSize: 25,
                    fontFamily: settingData.fontFM,
                }}>
                    {settingData.langDic['lang33']}
                </Typography>

                <Stack sx={{
                    width: '1100px',
                    mt: 5,
                    flexDirection: 'row',
                    alignContent: 'center',
                    justifyContent: 'center',
                }}>
                    <Stack sx={{
                        width: 0.4,
                        alignItems: 'center',
                        mr: 5,
                    }}>
                        <InputItem id='feed_name' title={settingData.langDic['lang34']} placeholder={settingData.langDic['lang35']} />
                        <InputItem id='feed_company' title={settingData.langDic['lang36']} placeholder={settingData.langDic['lang37']} />
                        <TextfieldItem id='feed_msg' placeholder={settingData.langDic['lang38']} />
                        <InputItem id='feed_email' title={settingData.langDic['lang39']} placeholder={settingData.langDic['lang40']} />
                        <InputItem id='feed_mobile' title={settingData.langDic['lang41']} placeholder={settingData.langDic['lang42']} />

                        <Typography
                            onClick={submitTap}
                            sx={{
                                width: '160px',
                                height: '43px',
                                lineHeight: '43px',
                                fontWeight: 'bold',
                                color: 'white',
                                textAlign: 'center',
                                borderRadius: '6px',
                                bgcolor: '#FF5F47',
                                cursor: 'pointer',
                                fontFamily: settingData.fontFM
                            }}>
                            {settingData.langDic['lang43']}
                        </Typography>
                    </Stack>

                    <Box
                        component={'img'}
                        src={getImgPath('email_img.png')}
                        sx={{
                            width: 0.32,
                            mb: 5,
                        }} />
                </Stack>

                <Box sx={{ flex: 1, mt: 3 }} />
                <PageFooter pageId={pageId} />
            </Stack>

            <FeedSuccessAlert />
        </Stack>
    );
}

function TextfieldItem(props) {
    const [inputValue, setInputValue] = React.useState('');

    function onBlur() {

    }

    function onFocus() {

    }

    function onChange(e) {
        setInputValue(e.target.value);
    }


    return (
        <Stack
            id={props.id}
            component={'textarea'}
            value={inputValue}
            placeholder={props.placeholder}
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={onChange}
            sx={{
                borderRadius: '6px',
                p: '10px',
                bgcolor: '#EBEBEB',
                mb: 1.5,
                width: 0.95,
                height: '130px',
                fontSize: 16,
                border: 0,
                outline: 'none',
                color: 'black',
                flex: 1,
                '&::placeholder': {
                    color: "gray",
                    fontWeight: 'bold',
                    fontFamily: '-moz-initial',
                },
            }} />

    );

}

function InputItem(props) {

    const [inputValue, setInputValue] = React.useState('');
    const [msg, setMsg] = React.useState('');
    const settingData = useSelector(state => state.settingData);

    function onBlur() {
        if (JSTool.isEmpty(inputValue)) {
            setMsg(props.placeholder);

        } else if ('email' == props.type && !JSTool.isEmail(inputValue)) {
            setMsg('The email address is unavailable');
        }
    }

    function onFocus() {
        setMsg('');
    }

    function onChange(e) {
        setInputValue(e.target.value);
    }


    return (
        <Stack sx={{
            width: 1,
            flexDirection: 'row',
            alignItems: 'center',
            height: '40px',
            borderRadius: '6px',
            overflow: 'hidden',
            bgcolor: '#EBEBEB',
            mb: 1.5,
        }}>
            <Typography sx={{
                width: '90px',
                textAlign: 'center',
                height: 1,
                lineHeight: '40px',
                color: 'white',
                bgcolor: 'black',
                fontWeight: 'bold',
                fontFamily: settingData.fontFM
            }}>
                {props.title}
            </Typography>

            <Stack
                id={props.id}
                component={'input'}
                type={props.type == 'password' ? 'password' : (props.type == 'code' ? 'number' : 'email')}
                value={inputValue}
                placeholder={props.placeholder}
                onBlur={onBlur}
                onFocus={onFocus}
                onChange={onChange}
                sx={{
                    height: 1,
                    px: 2,
                    fontSize: 16,
                    border: 0,
                    bgcolor: 'transparent',
                    outline: 'none',
                    color: 'black',
                    flex: 1,
                    '&::placeholder': {
                        color: "gray",
                        fontWeight: 'bold',
                        fontFamily: '-moz-initial',
                    },
                }} />
        </Stack>

    );

}